import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EventNoteIcon from '@material-ui/icons/EventNote';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CallIcon from '@material-ui/icons/Call';
import EmailIcon from '@material-ui/icons/Email';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import Grid from '@material-ui/core/Grid';
import AccordionContentList from './AccordionContent'
import OfflineDb from '../../db'

import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'

import { useTranslation } from 'react-i18next';

import { Button } from '@dhis2/ui';

import { red } from '@material-ui/core/colors';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    root: {
      maxWidth: 345,
      margin: '0 auto',
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    avatar: {
      backgroundColor: red[500],
    },
  }));

function AccordianList ({AccordionLabel, keyindex, AccordionContent, AccordionDataObject, TrackEntityId, Component, PropsArray,ClientName, AlertName}) {
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);
    const [expanded2, setExpanded2] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const listOfFields = PropsArray && PropsArray.progarmData ? PropsArray.progarmData.programs[0].programTrackedEntityAttributes : ''
    const fieldsToDisplay = listOfFields ? listOfFields.filter(obj => obj.displayInList == true) : ''

    const setGlobalSpinner = useGlobalSpinnerActionsContext()

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded2(isExpanded ? panel : false);
      };

    const seeIndividualRecordClick = () => {
    localStorage.setItem('trackedEntityInstance', TrackEntityId) // Update TrackentityId here
    localStorage.setItem('linkContact', false)
    localStorage.setItem('hidebutton', true)


    setAnchorEl(null);
    setGlobalSpinner(true)
    history.push('/layout/individualrecord', { 'trackedEntityInstance': TrackEntityId }); // Update TrackentityId here
    }

    function UpdateRecordClick() {
        setGlobalSpinner(true)
    
        const formDataMassaged = {}
        const activeCaseDetails = {
          'trackedEntityInstance': TrackEntityId,
          'enrollmentId': "",
          "type": PropsArray.type,
          "stageinstanceuid": PropsArray.stageinstanceuid,
          "stageuid": PropsArray?.alertdata?.services_uid //"cz7SrvIEwHl"
        }
        const activeCaseFormData = {
          'formFormat': null, //formDataMassaged,
          'dhisFormat': null
        }
        const linkContact = {
          "enabled": false,
          "linkTrackedEntityInstance": TrackEntityId
        }
        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
        OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
        if(Component == "TransferOut") {
          console.log('AccordionDataObject', PropsArray)
          const transfer = {
            "type": PropsArray.type,
            "stageinstanceuid": PropsArray.stageinstanceuid,
            "stageuid": PropsArray.services_uid
          }
          OfflineDb.setDataIntoPouchDB('transferFlag', transfer)
        }
        setGlobalSpinner(false)
        history.push('/layout/registration')
      }

    function dialPhone(){
      try{
        let filtered_array = _.find(
          fieldsToDisplay, function(o) {
            return o.trackedEntityAttribute && o.trackedEntityAttribute.description == "Phone number (permanent)";
          }
        );
        let phoneUID = null;
        if(filtered_array){
          phoneUID = filtered_array.trackedEntityAttribute.id
          let phoneNumber = phoneUID ? PropsArray.alertdata[phoneUID] : ''
          if(phoneNumber){
              window.open(`tel:${phoneNumber}`, '_system')
          }
        }
      }catch(e){

      }
    }

    function openEmail(){
      window.open('mailto:', '_system')
    }

    return (
            <Grid item xs={12} sm={12} md={12} className="newalerts knowkedgelistcontainer">
              
              <Accordion expanded={expanded2 === keyindex} onChange={handleChange(keyindex)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{margin:"0px"}}
              >
                <Typography className={classes.heading} style={{paddingTop:"10px"}}><EventNoteIcon /></Typography>
                  <Typography style={{padding: '10px 15px'}}>
                        {Component && (Component).trim() == 'Alert' && ClientName && AlertName ?
                          <><span>{ClientName}</span> - <span className='cl-red'>{AlertName}</span></>
                          :
                          AccordionLabel
                        }
                        {/* {AccordionLabel} */}
                    </Typography>
              </AccordionSummary>
              
                <AccordionDetails>
                    <div className="">
                        <AccordionContentList FromComponent={'Alert'} DataArray={AccordionDataObject} />
                        <p className="alerts_profilebtn_holder caselistviewbtnholder myClientsCaseList gg">
                        {/* <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn" onClick={seeIndividualRecordClick}>
                            <VisibilityIcon /><span className="ml-10px"></span>
                        </Button> */}
                        <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={UpdateRecordClick}>
                            <EditIcon /> <span className="ml-10px"></span>
                        </Button>
                        {
                          Component && Component == 'Alert' &&
                          <>
                          <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={dialPhone}>
                            <CallIcon /> <span className="ml-10px"></span>
                          </Button>
                          {/* <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={openEmail}>
                              <EmailIcon /> <span className="ml-10px"></span>
                          </Button> */}
                          {/* <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={UpdateRecordClick}>
                              <WhatsAppIcon /> <span className="ml-10px">{t('Share')}</span>
                          </Button> */}
                          </>
                        }
                    </p> 
                    </div> 
                      
              </AccordionDetails>
              
            </Accordion>
            </Grid>
        
    )

}

export default AccordianList